import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getSubadminListApiCall = createAsyncThunk("SubadminList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: subadminList } = await API.getSubadminApi(submitData);
        //  console.log("*********************************************",subadminList);
        dispatch(setLoader(false))
        return subadminList;
    } catch (error) {
        throw error;
    }
});

export const editSubadminDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editSubadminData, code, message } = await API.updateSubadminApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editSubadminData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    SubadminList: {
        data: [],
        error: null,
    },
    editSubadminData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const subadminSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSubadminListApiCall.fulfilled, (state, action) => {
                state.SubadminList.data = action.payload;
            })
            .addCase(getSubadminListApiCall.rejected, (state, action) => {
                state.SubadminList.error = action.error.message;
            })
            .addCase(editSubadminDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editSubadminData.data = data;
                state.editSubadminData.message = message;
                state.editSubadminData.code = code;
            })
            .addCase(editSubadminDataApiCall.rejected, (state, action) => {
                state.editSubadminData.error = action.error.message;
            });
    },
});

export default subadminSlice.reducer;